import { createGlobalStyle } from 'styled-components';
import { actionButton, cardSurface } from './tokens';

// Global também alcança portais de Modal, Tooltip e Popover.
const GlobalInterfaceStyle = createGlobalStyle`
  body, h1, h2, h3, h4, h5, h6, p, label, table,
  button, input, select, textarea,
  .btn, .form-control, .form-select, .form-label, .input-group-text,
  .modal, .card, .dropdown-menu, .popover, .tooltip, .nav, .pagination {
    font-family: var(--ui-font) !important;
  }
  .btn:not(.ui-cell-button):not(.ui-action-custom):not(.btn-link):not(.btn-close):not(.close) {
    ${actionButton}
    min-height: 40px; padding: 9px 14px; font-size: 13px; line-height: 1.4;
    white-space: normal; text-align: center;
    &.btn-sm { min-height: 32px; padding: 6px 10px; font-size: 12px; }
    &.btn-lg { min-height: 46px; padding: 11px 18px; font-size: 14px; }
  }
  .card {
    ${cardSurface}
    --bs-card-color: #243247;
    --bs-card-bg: #ffffff;
    --bs-card-cap-color: #243247;
    --bs-card-cap-bg: #f4f6fa;
  }
  .card > .card-header, .card > .card-footer {
    background-color: #f4f6fa; color: #243247;
  }
`;
export default GlobalInterfaceStyle;
